export default __webpack_public_path__ + "static/media/Politique_de_Confidentialite_Plateforme_FUB_Services_17_03_2022.a79acf9c.pdf";